export default __webpack_public_path__ + "static/boost-ffee69f0e1d24be3dbe31ec28e4a402c.gif";